import React, { FC, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Stack, Box, Modal, IconButton } from '@mui/material';

import RetryImg from '@shared/components/RetryImg';

import styles from './example-image-carousel.module.scss';

interface ExampleImagesCarouselProps {
  imageUrls: string[];
}

const ExampleImagesCarousel: FC<ExampleImagesCarouselProps> = ({
  imageUrls,
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  
  // Используем прямые URL'ы (как в конструкторах)
  const directImageUrls = imageUrls;

  const handleImageClick = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <Box 
        className={styles.stackImage}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          gap: { xs: '2px', sm: '30px' },
          border: 'none',
          padding: 0,
          '& img': {
            flex: '0 0 auto',
            width: 'auto',
            height: 'auto',
            maxWidth: 'calc(33.333% - 25.5px)',
            maxHeight: { xs: '200px', sm: '300px' },
            objectFit: 'contain',
            minWidth: 0
          }
        }}
      >
        {directImageUrls.map((url: string, index: number) => (
          <RetryImg
            key={`${url}-${index}`}
            alt=""
            src={url}
            maxRetries={3}
            retryDelayMs={1000}
            style={{ 
              flex: '0 0 auto',
              width: 'auto',
              height: 'auto',
              maxWidth: 'calc(33.333% - 0.5px)',
              maxHeight: '300px',
              cursor: 'pointer',
              objectFit: 'contain'
            }}
            onClick={() => handleImageClick(url)}
          />
        ))}
      </Box>
      
      {/* Модальное окно для увеличенного изображения */}
      <Modal
        open={!!selectedImage}
        onClose={handleCloseModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              bgcolor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(0, 0, 0, 0.7)',
              },
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedImage && (
            <RetryImg
              src={selectedImage || undefined}
              alt=""
              maxRetries={3}
              retryDelayMs={1000}
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '90vh',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          )}
        </Box>
      </Modal>
    </>
  );
};

export default ExampleImagesCarousel;
